__turbopack_context__.v({
  "banner": "CallToAction-module__v0_D9G__banner",
  "btnOutline": "CallToAction-module__v0_D9G__btnOutline",
  "btnWhite": "CallToAction-module__v0_D9G__btnWhite",
  "buttonGroup": "CallToAction-module__v0_D9G__buttonGroup",
  "content": "CallToAction-module__v0_D9G__content",
  "ctaSection": "CallToAction-module__v0_D9G__ctaSection",
  "glowBlob1": "CallToAction-module__v0_D9G__glowBlob1",
  "glowBlob2": "CallToAction-module__v0_D9G__glowBlob2",
  "logoIcon": "CallToAction-module__v0_D9G__logoIcon",
  "subtitle": "CallToAction-module__v0_D9G__subtitle",
  "textGroup": "CallToAction-module__v0_D9G__textGroup",
  "title": "CallToAction-module__v0_D9G__title",
});
